var React = require('react');

function LuggageCart (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M480 48a48 48 0 0 0-48-48h-96a48 48 0 0 0-48 48v272h192zm-48 48h-96V48h96zm-240 32v160a32 32 0 0 0 32 32h32V96h-32a32 32 0 0 0-32 32zm352-32h-32v224h32a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32zm-93.26 352a48 48 0 1 0 90.52 0zm-288 0a48 48 0 1 0 90.52 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M624 384H128V16a16 16 0 0 0-16-16H16A16 16 0 0 0 0 16v32a16 16 0 0 0 16 16h48v368a16 16 0 0 0 16 16h544a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM288 96h-32v224h32zm224 0h-32v224h32z","className":"fa-primary","key":2})]);
}

LuggageCart.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = LuggageCart;

LuggageCart.default = LuggageCart;
